import { jsx as _jsx, jsxs as _jsxs } from "nativewind/jsx-runtime";
import { createNativeStackNavigator, } from '@react-navigation/native-stack';
import React from 'react';
import LeftArrowIcon from '@/assets/icon/ic_arrow_left.svg';
import CloseIcon from '@/assets/icon/ic_x_black.svg';
import { SccPressable } from '@/components/SccPressable';
import { color } from '@/constant/color';
import { MainNavigationScreens, } from './Navigation.screens';
import { webOnlyScreens } from './webScreens';
import { withModalPresentation } from './withModalPresentation';
import * as S from './Navigation.style';
const AllNavigationScreens = [...MainNavigationScreens, ...webOnlyScreens];
const Stack = createNativeStackNavigator();
export const NavigationHeader = ({ navigation, title, variant = 'back', onBackPress, }) => {
    const handleBack = () => {
        if (onBackPress) {
            onBackPress();
        }
        else if (navigation.canGoBack()) {
            navigation.goBack();
        }
    };
    return (_jsx(S.Container, { edges: ['top'], children: variant === 'back' ? (_jsxs(S.ContentsContainer, { children: [_jsx(SccPressable, { elementName: "navigation_back_button", hitSlop: 15, onPress: handleBack, children: _jsx(LeftArrowIcon, { width: 16, height: 14, color: color.black }) }), _jsx(S.Title, { ellipsizeMode: "tail", children: title })] })) : (_jsxs(S.ContentsContainer, { style: { justifyContent: 'space-between' }, children: [_jsx(S.Title, { ellipsizeMode: "tail", children: title }), _jsx(SccPressable, { elementName: "close_button", logParams: { screen_name: title }, hitSlop: 8, onPress: handleBack, children: _jsx(CloseIcon, { width: 28, height: 28, color: color.black }) })] })) }));
};
export const Navigation = () => {
    return (_jsx(Stack.Navigator, { initialRouteName: "Intro", screenOptions: () => ({
            headerShown: false,
            // native-stack screen 컨테이너 기본값이 투명이라, 화면 전환 중/후에
            // GestureHandlerRootView 등 상위 트리의 배경색이 leak된다. 모든 화면을
            // 흰 배경으로 강제해 leak 차단. (특정 화면이 투명 필요시 override)
            contentStyle: { backgroundColor: color.white },
            // eslint-disable-next-line react/no-unstable-nested-components
            header: ({ options, navigation }) => {
                const customOptions = options;
                const title = typeof options.headerTitle === 'string' ? options.headerTitle : '';
                if (!(typeof options.headerTitle === 'string')) {
                    console.warn('Currently non-string headerTitle is not supported.');
                }
                const variant = typeof customOptions.variant === 'string'
                    ? customOptions.variant
                    : undefined;
                return (_jsx(NavigationHeader, Object.assign({ title: title, navigation: navigation, variant: variant }, options, { onBackPress: customOptions.onBackPress })));
            },
        }), children: AllNavigationScreens.map(screen => (_jsx(Stack.Screen, { name: screen.name, component: screen.component, options: withModalPresentation(screen.options) }, screen.name))) }));
};
